<template>
    <div :class="'click-show-list ' + cls + (isOpen ? ' show-list' : '')">
        <div class="box-div">
            <div class="name" v-if="!hide_name">{{ name }}</div>
            <div class="title" @click="toggle">
                <span v-if="icon" :class="'logo iconfont ' + icon"></span>
                <input
                    v-if="filterShow"
                    type="search"
                    autocomplete="off"
                    :placeholder="label"
                    class="filter-input"
                    maxlength="50"
                    :value="isOpen ? filterValue : label"
                    @input="searchInput"
                />
                <label v-else class="text">
                    <span v-if="showSortBy" class="sort-by">{{ $t('common:sortBy') }}</span>
                    {{ label }}
                </label>
                <span
                    :class="[
                        'dropdown_icon',
                        'iconfont',
                        dropdownIcon || 'icon-arrow-down'
                    ]"
                ></span>
            </div>
            <action-sheet
                v-if="showMobileStyle"
                v-show="isOpen || keepOpen"
                @close="close"
            >
                <slot></slot>
            </action-sheet>
            <ul
                :class="['list-panel', inner_cls]"
                v-else
                v-outsideclick="outsideClick"
                v-show="isOpen || keepOpen"
                :style="listStyle"
            >
                <slot></slot>
            </ul>
        </div>
    </div>
</template>
<script>
import util from '../common/util';
import ActionSheet from './actionsheet.vue';
export default {
    components: { ActionSheet },
    emits: ['filterChange', 'toogledropdown', 'open'],
    i18next: {
        ns: 'common'
    },
    props: {
        name: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        cls: {
            type: String,
            default: ''
        },
        inner_cls: {
            type: String,
            default: ''
        },
        hide_name: {
            type: Boolean,
            default: false
        },
        keepOpen: {
            type: Boolean,
            default: false
        },
        dropdownIcon: {
            type: String,
            default: ''
        },
        filterShow: {
            type: Boolean,
            default: false
        },
        mobileStyleWhenMobile: {
            type: Boolean,
            default: false
        },
        showSortBy: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            isOpen: false,
            listStyle: null,
            filterValue: ''
        };
    },
    methods: {
        toggle(e) {
            e.outSideIgnore = this.outsideClick;
            if (!this.isOpen) {
                this.isOpen = true;
            } else {
                this.close();
            }
        },
        outsideClick() {
            this.close();
        },
        close() {
            this.isOpen = false;
        },
        searchInput($event) {
            this.$emit('filterChange', $event.target.value);
            this.filterValue = $event.target.value;
        }
    },
    computed: {
        showMobileStyle() {
            return this.platform.isMobile && this.mobileStyleWhenMobile;
        }
    },
    created() {
    },
    watch: {
        isOpen() {
            if (this.isOpen) {
                let ele = this.$el,
                    rect = ele.getBoundingClientRect(),
                    pos = rect.bottom,
                    pele = util.getScrollPelem(ele),
                    height =
                        Math.max(
                            pele.getBoundingClientRect().bottom,
                            window.innerHeight
                        ) - pos;
                if (height < 200) {
                    // let pstop = pele.scrollTop;
                    // if(this.cls.indexOf('mobile') !== -1){
                    //     pele.scrollTop = pstop + rect.top - 100;
                    // }
                    height = height + rect.top - 100;
                }
                if (
                    !(
                        this.cls &&
                        this.cls.indexOf('show-filter') !== -1 &&
                        this.cls.indexOf('mobile') !== -1
                    )
                ) {
                    this.listStyle = {
                        maxHeight: height + 'px'
                    };
                }
                this.$emit('toogledropdown', true);
                this.$emit('open');
                this.filterShow && this.$emit('filterChange', '');
                this.filterShow && (this.filterValue = '');
            } else {
                this.$emit('toogledropdown', false);
            }
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/mixin.scss';
.click-show-list {
    position: relative;
    @include color-button-hover();
    .dropdown_icon {
        width: 15px;
    }
    &.show-list .title {
        .icon-arrow-down {
            transform: rotate(180deg);
        }
    }
    .list-panel {
        position: absolute;
        top: calc(100% + 5px);
        left: 0;
        min-width: 100%;
        z-index: 100;
    }
    .text {
        .sort-by {
            color: var(--g-tip-color);
        }
    }
}
</style>
